import { render } from "./ComponentB.vue?vue&type=template&id=d0abd730"
import script from "./ComponentB.vue?vue&type=script&lang=js"
export * from "./ComponentB.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rominpatel/Documents/sites/bluegempartners/wp-content/themes/everge/packages/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__